import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=2ac83f7e&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac83f7e",
  null
  
)

export default component.exports